<div style="min-width: 45vw; max-width: 650px">
    <form [formGroup]="milestoneForm">
        <!-- Section -->
        <div class="w-full pb-4 border-b">
            <div class="text-xl">Invoice Milestone Reminder</div>
        </div>

        <div class="grid w-full dialog-content-height-scroll">
            <div
                class="grid sm:grid-cols-4 gap-x-4 gap-y-3 w-full mt-4 notification-popup-cont pb-4"
            >
                <!-- Job Name: Ancient Apocalypse II
        Total Project Budget: £325,000
        Stage of Invoice (ie. 1st 50%, 2nd 50%): third invoice – 30%
        Job Number: HC2477
        Description of work (scope of work): Graphics and VFX for Series 2 - full
        Amount to be invoiced (not incl VAT): £97,500
        Currency: £ GBP
        VAT applicable: YES
        Amount to be invoiced (incl VAT): £117,000
        Client: ITN
        Contact Name: Amber.Lambert@itn.co.uk
        P.O. Ref: As per email dated 4 Sept -->

                <div class="sm:col-span-2">
                    <strong>Job Name: </strong>{{ milestone.projectName }}
                </div>
                <div class="sm:col-span-2">
                    <strong>Project Ref: </strong>{{ milestone.projectRef }}
                </div>
                <div class="sm:col-span-2">
                    <strong>Stage of Invoice: </strong>Stage
                    {{ milestone.stage }}
                </div>
                <div class="sm:col-span-2">
                    <strong>Total Project Budget: </strong
                    >{{ milestone.projectBudget | currency: "GBP" }}
                </div>
                <div class="sm:col-span-4">
                    <strong>Description of work: </strong
                    >{{ milestone.description }}
                </div>

                <!-- Divider -->
                <div class="sm:col-span-4 my-2 border-t"></div>

                <div class="sm:col-span-4">
                    <strong>Amount to be invoiced (excl. VAT): </strong>
                    {{
                        milestone.fixedAmount || milestone.amount
                            | currency: "GBP"
                    }}
                    @if (usesAlternativeCurrency()) {
                        <span
                            >({{
                                (milestone.fixedAmount || milestone.amount) *
                                    (milestone.fixedCurrencyRate ||
                                        milestone.currencyRate)
                                    | currency: GetCurrencyPipeValue()
                            }})</span
                        >
                    }
                </div>

                <div class="sm:col-span-4">
                    <strong>Currency: </strong>

                    @if (!!this.milestone?.currencyType) {
                        <mat-slide-toggle
                            class="ml-2"
                            style="height: 20px !important"
                            [color]="'primary'"
                            [formControlName]="'useAltCurrency'"
                        >
                            {{
                                getCurrencyTypeText(
                                    milestoneForm?.controls["useAltCurrency"]
                                        .value
                                        ? milestone.currencyType
                                        : CurrencyType.GBP
                                )
                            }}
                        </mat-slide-toggle>
                    }

                    @if (!this.milestone?.currencyType) {
                        <span>{{ getCurrencyTypeText(CurrencyType.GBP) }}</span>
                    }
                </div>

                <div class="sm:col-span-4 flex flex-row items-center gap-2">
                    <strong>VAT Applicable: </strong>
                    <mat-slide-toggle
                        style="height: 20px !important"
                        [color]="'primary'"
                        [formControlName]="'vatApplicable'"
                    >
                    </mat-slide-toggle>
                </div>

                <div class="sm:col-span-4">
                    <strong>Amount to be invoiced (incl. VAT): </strong>
                    {{
                        (milestone.fixedAmount || milestone.amount) *
                            (milestoneForm?.controls["vatApplicable"].value
                                ? 1.2
                                : 1) | currency: "GBP"
                    }}
                    @if (usesAlternativeCurrency()) {
                        <span
                            >({{
                                (milestone.fixedAmount || milestone.amount) *
                                    (milestoneForm?.controls["vatApplicable"]
                                        .value
                                        ? 1.2
                                        : 1) *
                                    (milestone.fixedCurrencyRate ||
                                        milestone.currencyRate)
                                    | currency: GetCurrencyPipeValue()
                            }})</span
                        >
                    }
                </div>

                <!-- Divider -->
                <div class="sm:col-span-4 my-2 border-t"></div>

                <div class="sm:col-span-4 flex flex-row items-center gap-2">
                    <strong class="w-[124px]">Date: </strong>
                    <mat-form-field
                        class="fuse-mat-dense flex-1"
                        [subscriptSizing]="'dynamic'"
                    >
                        <input
                            [formControlName]="'date'"
                            [matDatepicker]="notifPicker"
                            matInput
                        />
                        <mat-datepicker-toggle
                            matIconSuffix
                            [for]="notifPicker"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #notifPicker></mat-datepicker>
                    </mat-form-field>
                </div>

                <div class="sm:col-span-4 flex flex-row items-center gap-2">
                    <strong class="w-[124px]">Client: </strong>
                    <mat-form-field
                        class="fuse-mat-dense flex-1"
                        [subscriptSizing]="'dynamic'"
                    >
                        <mat-select
                            [formControlName]="'companyName'"
                            [panelClass]="'w-full min-w-40 h-auto max-h-72'"
                            disableOptionCentering
                            (selectionChange)="companyChanged()"
                        >
                            @for (company of companies; track company) {
                                <mat-option [value]="company.name">
                                    <div class="font-medium">
                                        {{ company.name }}
                                    </div>
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <!-- {{milestone.companyName}} -->
                </div>

                <div class="sm:col-span-4 flex flex-row items-center gap-2">
                    <strong class="w-[124px]">Contact: </strong>
                    <mat-form-field
                        class="fuse-mat-dense flex-1"
                        [subscriptSizing]="'dynamic'"
                    >
                        <mat-select
                            [formControlName]="'mainContactEmail'"
                            [panelClass]="'w-full min-w-40 h-auto max-h-72'"
                            disableOptionCentering
                        >
                            @for (email of getEmails(); track email) {
                                <mat-option [value]="email">
                                    <div class="font-medium">{{ email }}</div>
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <!-- {{milestone.mainContactEmail}} -->
                </div>

                <div
                    class="sm:col-span-4 flex flex-row items-center gap-2 whitespace-pre"
                >
                    <strong class="w-[124px]">Invoice Address: </strong>
                    <mat-form-field
                        class="fuse-mat-dense flex-1"
                        [subscriptSizing]="'dynamic'"
                    >
                        <mat-select
                            [formControlName]="'invoiceAddressId'"
                            [panelClass]="'w-full min-w-40 h-auto max-h-72'"
                            disableOptionCentering
                        >
                            @for (address of getAddresses(); track address) {
                                <mat-option [value]="address.projectAddressId">
                                    <div class="font-medium">
                                        {{ address.addressOne }}
                                    </div>
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <!-- {{milestone.invoiceAddress.addressOne}} -->
                </div>

                <div class="sm:col-span-4 flex flex-row items-center gap-2">
                    <strong class="w-[124px]">PO Ref: </strong>
                    <mat-form-field
                        class="fuse-mat-dense flex-1"
                        [subscriptSizing]="'dynamic'"
                        style="height: 21px !important"
                    >
                        <input
                            style="height: 20px !important"
                            [formControlName]="'poRef'"
                            matInput
                        />
                    </mat-form-field>
                </div>

                <div class="sm:col-span-4 flex flex-row items-center gap-2">
                    <strong class="w-[124px]">Payment Terms: </strong>
                    <mat-form-field
                        class="fuse-mat-dense flex-1"
                        [subscriptSizing]="'dynamic'"
                        style="height: 21px !important"
                    >
                        <input
                            style="height: 20px !important"
                            [formControlName]="'paymentTerms'"
                            matInput
                        />
                    </mat-form-field>
                </div>

                <div class="sm:col-span-4 flex flex-row gap-2">
                    <strong class="w-[124px]">Notes: </strong>
                    <mat-form-field
                        class="fuse-mat-dense flex-1"
                        [subscriptSizing]="'dynamic'"
                    >
                        <textarea
                            [formControlName]="'notes'"
                            matInput
                            cdkTextareaAutosize
                            [cdkAutosizeMinRows]="1"
                        >
                        </textarea>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <!-- Divider -->
        <div class="mt-2 mb-6 border-b"></div>

        <!-- Actions -->
        <div class="flex items-center justify-end gap-4">
            <button
                class="mr-auto"
                (click)="close()"
                mat-stroked-button
                type="button"
            >
                Cancel
            </button>

            <button mat-stroked-button type="button" (click)="saveDetails()">
                Save without Submitting
            </button>

            <button
                (click)="submitMilestone()"
                mat-flat-button
                type="button"
                [color]="'primary'"
                [disabled]="!milestoneForm?.valid"
            >
                Submit to Accounts
            </button>

            <!-- <button
            *ngIf="changingDate"
            (click)="saveDate()"
            class="ml-4"
            mat-flat-button
            type="button"
            [color]="'primary'"
            [disabled]="!milestoneForm.controls['date'].valid || milestoneForm.controls['date'].pristine">
            Save
          </button> -->
        </div>
    </form>
</div>
